module.exports = __webpack_public_path__ + "img/bg5.48006a5b.jpg";